import type { AnyExtension } from "@tiptap/core"
import { ColorItemWithNodeView } from "./color-node-view"
import { ExpandableWithNodeView } from "./expandable-node-view"
import { FieldsWithNodeView } from "./fields-node-view"
import { MermaidWithNodeView } from "./mermaid-node-view"
import { TreeWithNodeView } from "./tree-node-view"

const NODE_VIEWS: AnyExtension[] = [
	...FieldsWithNodeView,
	ExpandableWithNodeView,
	...TreeWithNodeView,
	MermaidWithNodeView,
	ColorItemWithNodeView,
]

const REPLACED = new Set(NODE_VIEWS.map((extension) => extension.name))

/** The shared schema carries these nodes bare; the dashboard edits them through their views. */
export function withMintlifyNodeViews(
	extensions: AnyExtension[],
): AnyExtension[] {
	return [
		...extensions.filter((extension) => !REPLACED.has(extension.name)),
		...NODE_VIEWS,
	]
}
